import script from "./OtherExpenses.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherExpenses.vue?vue&type=script&setup=true&lang=js"

import "./OtherExpenses.vue?vue&type=style&index=0&id=1f7bc410&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f7bc410"]])

export default __exports__